import i18n from "i18next";

export const landslideIspraLegendLevels = () => ({
  noHazard: `${i18n.t("levels.noHazard")}`,
  attentionZones: `${i18n.t("levels.attentionZones")}`,
  moderate: `${i18n.t("levels.moderate")}`,
  medium: `${i18n.t("levels.medium")}`,
  high: `${i18n.t("levels.high")}`,
  veryHigh: `${i18n.t("levels.veryHigh")}`,
});
